import {useEffect, useState} from 'react';
import {getFeatureValue} from '../services/featureHubClient';

export function useFeature(featureKey, sourceValue = null) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const updateFeature = () => {
      const newValue = getFeatureValue(featureKey, false, sourceValue);
      setEnabled(newValue);
    };

    updateFeature();

    const interval = setInterval(updateFeature, 30000);

    return () => {
      clearInterval(interval);
    };
  }, [featureKey, sourceValue]);

  return enabled;
}
